import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Button } from './Button';
interface NavbarProps {
  currentPage: string;
  setPage: (page: 'home' | 'about' | 'contact') => void;
}
export function Navbar({
  currentPage,
  setPage
}: NavbarProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navLinks = [{
    id: 'home',
    label: 'Home'
  }, {
    id: 'about',
    label: 'About & Treatments'
  }, {
    id: 'contact',
    label: 'Contact'
  }] as const;
  const handleNavClick = (page: 'home' | 'about' | 'contact') => {
    setPage(page);
    setIsMobileMenuOpen(false);
  };
  return <header className="sticky top-0 z-50 w-full bg-white shadow-sm" data-id="element-35">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-36">
        <div className="flex justify-between items-center h-20" data-id="element-37">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center cursor-pointer" onClick={() => handleNavClick('home')} role="button" tabIndex={0} onKeyDown={e => e.key === 'Enter' && handleNavClick('home')} data-id="element-38">
            <span className="font-heading text-2xl font-bold text-primary tracking-tight" data-id="element-39">
              [LOGO]
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-40">
            {navLinks.map(link => <button key={link.id} onClick={() => handleNavClick(link.id)} className={`text-base font-medium transition-colors hover:text-accent ${currentPage === link.id ? 'text-primary border-b-2 border-accent' : 'text-charcoal'}`} data-id="element-41">
                {link.label}
              </button>)}
            <Button onClick={() => handleNavClick('contact')} variant="primary" data-id="element-42">
              Schedule your tele-health appointment
            </Button>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-43">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-charcoal hover:text-primary focus:outline-none p-2" aria-expanded={isMobileMenuOpen} aria-label="Toggle navigation menu" data-id="element-44">
              {isMobileMenuOpen ? <XIcon className="h-6 w-6" aria-hidden="true" data-id="element-45" /> : <MenuIcon className="h-6 w-6" aria-hidden="true" data-id="element-46" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && <div className="md:hidden bg-white border-t border-gray-100 shadow-lg absolute w-full" data-id="element-47">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-48">
            {navLinks.map(link => <button key={link.id} onClick={() => handleNavClick(link.id)} className={`block w-full text-left px-3 py-4 text-base font-medium ${currentPage === link.id ? 'text-primary bg-cream' : 'text-charcoal hover:bg-gray-50 hover:text-primary'}`} data-id="element-49">
                {link.label}
              </button>)}
            <div className="pt-4 px-3" data-id="element-50">
              <Button onClick={() => handleNavClick('contact')} variant="primary" className="w-full" data-id="element-51">
                Schedule Appointment
              </Button>
            </div>
          </div>
        </div>}
    </header>;
}